import { Box } from '@mui/material';
import type { Theme } from '@mui/system';
import type { ComponentProps } from 'react';
import { combineSx, type SXVariantProps, sxVariants } from '@/utils/combineSx';

const badgeStylesVariants = sxVariants({
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.25rem',
    padding: '0.075rem 0.5rem',
    fontSize: '0.625rem',
    lineHeight: '1.5',
  },
  variants: {
    variant: {
      ma: (theme: Theme) => ({
        backgroundColor: theme.palette.accent.backgroundColor,
        border: `1px solid ${theme.palette.baseColors.iceBlue.c50}`,
        color: theme.palette.accent.color,
      }),
      default: (theme: Theme) => ({
        backgroundColor: theme.palette.baseColors.iceBlue.c50,
        border: `1px solid ${theme.palette.baseColors.iceBlue.c100}`,
      }),
    },
    disabled: {
      true: (theme: Theme) => ({ opacity: 0.4, color: theme.palette.text.disabled }),
      false: { opacity: 1 },
    },
  },
});

type BadgeProps = ComponentProps<typeof Box> &
  SXVariantProps<typeof badgeStylesVariants> & {
    component?: HTMLElement | string;
  };

const Badge = ({ children, variant = 'default', disabled = false, sx, ...props }: BadgeProps) => (
  <Box sx={combineSx(badgeStylesVariants({ variant, disabled }), sx)} data-id='badge' {...props}>
    {children}
  </Box>
);

export { Badge };
